
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MeltingReturnSelectGrid extends _Ext.GridBase<MeltingItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MeltingItems'; }
        protected getDialogType() { return <any>MeltingItemsDialog; }
        protected getIdProperty() { return MeltingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MeltingItemsRow.localTextPrefix; }
        //protected getInsertPermission() { return MeltingItemsRow.insertPermission; }
        //protected getUpdatePermission() { return MeltingItemsRow.updatePermission; }
        //protected getDeletePermission() { return MeltingItemsRow.deletePermission; }
        //protected useViewMode() { return true; } 
        //static items = [];
    
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;

        //protected createSlickGrid(): Slick.Grid {
        //    let grid = super.createSlickGrid();
        //    var olditems = MeltingReturnSelectGrid.items;
        //    var i = 1;
        //    for (let item of olditems) {
        //        var newitem: MeltingItemsRow = item;
        //        newitem[this.getIdProperty()] = item.TransItemId;
        //        newitem.TransItemId = i;
        //        this.view.addItem(newitem);
        //        //   alert('ID ' + rateitem.CostId);
        //        i++;
        //    }
        //    //grid.setData(olditems, true);
        //    //var c = grid.getData();

        //    return grid;
        //}

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): MeltingItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}